var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9622 7.07529C14.7965 7.07529 14.6581 7.21378 14.6581 7.37948V41.1703C14.6581 41.336 14.7965 41.4745 14.9622 41.4745H33.0376C33.2033 41.4745 33.3417 41.336 33.3417 41.1703V7.37948C33.3417 7.21378 33.2033 7.07529 33.0376 7.07529H14.9622ZM13.2581 7.37948C13.2581 6.44058 14.0233 5.67529 14.9622 5.67529H33.0376C33.9765 5.67529 34.7417 6.44058 34.7417 7.37948V41.1703C34.7417 42.1092 33.9765 42.8745 33.0376 42.8745H14.9622C14.0233 42.8745 13.2581 42.1092 13.2581 41.1703V7.37948Z",
    fill: "#9BE7C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9497 39.2624C24.5043 39.2624 24.9539 38.8128 24.9539 38.2582C24.9539 37.7036 24.5043 37.254 23.9497 37.254C23.3951 37.254 22.9456 37.7036 22.9456 38.2582C22.9456 38.8128 23.3951 39.2624 23.9497 39.2624Z",
    fill: "#9BE7C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9498 37.954C23.7818 37.954 23.6456 38.0902 23.6456 38.2582C23.6456 38.4262 23.7818 38.5624 23.9498 38.5624C24.1178 38.5624 24.254 38.4262 24.254 38.2582C24.254 38.0902 24.1178 37.954 23.9498 37.954ZM22.2456 38.2582C22.2456 37.317 23.0086 36.554 23.9498 36.554C24.891 36.554 25.654 37.317 25.654 38.2582C25.654 39.1994 24.891 39.9624 23.9498 39.9624C23.0086 39.9624 22.2456 39.1994 22.2456 38.2582Z",
    fill: "#9BE7C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1326 9.63889C19.1326 9.25229 19.446 8.93889 19.8326 8.93889H27.9163C28.3029 8.93889 28.6163 9.25229 28.6163 9.63889C28.6163 10.0255 28.3029 10.3389 27.9163 10.3389H19.8326C19.446 10.3389 19.1326 10.0255 19.1326 9.63889Z",
    fill: "#9BE7C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9c3c2ce3442ceb3e585700009b266536.svg";
export { ForwardRef as ReactComponent };